import {
  createFormState,
  onlyNaturals,
  hasNumber,
  hasLength,
} from 'redux-freeform';

const ordersIndexFiltersFormConfig = {
  orderNumber: {
    validators: [onlyNaturals()],
    constraints: [onlyNaturals()],
  },
  startDate: {
    constraints: [hasLength(0, 8)],
    validators: [hasLength(8, 8)],
  },
  endDate: {
    constraints: [hasLength(0, 8)],
    validators: [hasLength(8, 8)],
  },
  maxAmount: {
    constraints: [hasNumber()],
    validators: [hasNumber()],
  },
  minAmount: {
    constraints: [hasNumber()],
    validators: [hasNumber()],
  },
  agency: {},
  paymentMethod: {},
  status: {},
  batch: {},
  user: {},
  location: { defaultValue: 'all' },
  terminal: { defaultValue: 'all' },
};

export const { reducer, mapStateToProps, mapDispatchToProps } = createFormState(
  ordersIndexFiltersFormConfig,
);
